import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import GrinMenu from 'components/common/menu/GrinMenu'
import { IconButton } from '@material-ui/core'
import KebabMenu from 'components/common/icons/KebabMenu'
import GrinMenuItem from 'components/common/menu/GrinMenuItem'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import useGaFlags from 'hooks/useGaFlags'
import useGenericApplianceCopy from 'hooks/useGenericApplianceCopy'

const AlignerMenu = ({ isOpen, setIsOpen, withAligner, onEditAlignerNumberClicked, onSwitchWithAlignersClicked }) => {
  const useGenericCopy = useGenericApplianceCopy()
  const { t } = useTranslation()

  const { switchAligner: switchAlignerGaFlag } = useGaFlags()

  const handleActionClick = useCallback(
    actionCallback => {
      setIsOpen(false)
      actionCallback()
    },
    [setIsOpen]
  )

  return (
    <GrinMenu
      id="scan-feed-aligner-menu-button"
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      triggerComponent={
        <IconButton size="small">
          <KebabMenu />
        </IconButton>
      }
    >
      <GrinMenuItem
        id="scan-feed-aligner-menu-edit-aligner-number"
        onClick={() => handleActionClick(onEditAlignerNumberClicked)}
      >
        <DazzedParagraph14 strong>
          {t('pages.patients.selectedPatient.timelineV2.scanHeader.editAlignerNumber')}
        </DazzedParagraph14>
      </GrinMenuItem>
      {switchAlignerGaFlag && (
        <GrinMenuItem
          id="scan-feed-aligner-menu-switch-with-aligners"
          onClick={() => handleActionClick(onSwitchWithAlignersClicked)}
        >
          <DazzedParagraph14 strong>
            {withAligner
              ? t(
                  useGenericCopy
                    ? 'pages.patients.selectedPatient.timelineV2.scanHeader.markAsWithoutAppliance'
                    : 'pages.patients.selectedPatient.timelineV2.scanHeader.markAsWithoutAligners'
                )
              : t(
                  useGenericCopy
                    ? 'pages.patients.selectedPatient.timelineV2.scanHeader.markAsWithAppliance'
                    : 'pages.patients.selectedPatient.timelineV2.scanHeader.markAsWithAligners'
                )}
          </DazzedParagraph14>
        </GrinMenuItem>
      )}
    </GrinMenu>
  )
}

export default AlignerMenu
